"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardFilters = void 0;
exports.autoGranularity = autoGranularity;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var datePresets_1 = require("../../helpers/analytics/datePresets");
var date_field_1 = require("../form/date-field");
var GRANULARITY_OPTIONS = [
    { key: "daily", label: "Day" },
    { key: "weekly", label: "Week" },
    { key: "monthly", label: "Month" },
];
var PRESET_TO_DAYS = {
    today: 0,
    "7d": 7,
    "14d": 14,
    "30d": 30,
    "90d": 90,
    "6m": 180,
    "1y": 365,
    all: 365 * 4,
};
function autoGranularity(rangeDays) {
    if (rangeDays <= 14)
        return "daily";
    if (rangeDays <= 90)
        return "weekly";
    return "monthly";
}
function rangeDaysForPreset(preset) {
    var _a;
    return (_a = PRESET_TO_DAYS[preset !== null && preset !== void 0 ? preset : "30d"]) !== null && _a !== void 0 ? _a : 30;
}
function rangeDaysForCustom(start, end) {
    return Math.max(1, Math.round((end.getTime() - start.getTime()) / 86400000));
}
var DashboardFilters = function (_a) {
    var onFilterChange = _a.onFilterChange, className = _a.className;
    var _b = (0, react_2.useState)("30d"), selectedPreset = _b[0], setSelectedPreset = _b[1];
    var _c = (0, react_2.useState)(null), customStartDate = _c[0], setCustomStartDate = _c[1];
    var _d = (0, react_2.useState)(null), customEndDate = _d[0], setCustomEndDate = _d[1];
    var _e = (0, react_2.useState)(false), isCustomRange = _e[0], setIsCustomRange = _e[1];
    var _f = (0, react_2.useState)(autoGranularity(rangeDaysForPreset("30d"))), granularity = _f[0], setGranularity = _f[1];
    var _g = (0, react_2.useState)(true), granularityAuto = _g[0], setGranularityAuto = _g[1];
    var applyAutoGranularity = function (rangeDays) {
        var auto = autoGranularity(rangeDays);
        setGranularity(auto);
        return auto;
    };
    var handlePresetChange = function (preset) {
        setSelectedPreset(preset);
        setIsCustomRange(false);
        var nextGran = granularityAuto ? applyAutoGranularity(rangeDaysForPreset(preset)) : granularity;
        onFilterChange({
            date_range: { preset: preset },
            granularity: nextGran,
        });
    };
    var handleCustomDateChange = function () {
        if (!customStartDate || !customEndDate)
            return;
        var start = new Date(customStartDate.year, customStartDate.month - 1, customStartDate.day);
        var end = new Date(customEndDate.year, customEndDate.month - 1, customEndDate.day);
        var nextGran = granularityAuto ? applyAutoGranularity(rangeDaysForCustom(start, end)) : granularity;
        onFilterChange({
            date_range: { custom: { start: start, end: end } },
            granularity: nextGran,
        });
    };
    var handleGranularityChange = function (next) {
        setGranularityAuto(false);
        setGranularity(next);
        var date_range = isCustomRange && customStartDate && customEndDate
            ? {
                custom: {
                    start: new Date(customStartDate.year, customStartDate.month - 1, customStartDate.day),
                    end: new Date(customEndDate.year, customEndDate.month - 1, customEndDate.day),
                },
            }
            : { preset: selectedPreset };
        onFilterChange({ date_range: date_range, granularity: next });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, react_1.cn)("flex flex-wrap items-center gap-1.5", className), children: [(0, jsx_runtime_1.jsx)(react_1.ButtonGroup, { children: datePresets_1.DATE_PRESETS.slice(0, 5).map(function (preset) {
                    var active = selectedPreset === preset.key && !isCustomRange;
                    return ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "tertiary", className: (0, react_1.cn)("min-w-0 px-3 text-xs font-medium", active && "bg-primary/10 text-primary"), onPress: function () { return handlePresetChange(preset.key); }, children: preset.label }, preset.key));
                }) }), (0, jsx_runtime_1.jsxs)(react_1.Select, { "aria-label": "More ranges", placeholder: "More\u2026", value: isCustomRange ? "custom" : datePresets_1.DATE_PRESETS.slice(5).some(function (preset) { return preset.key === selectedPreset; }) ? selectedPreset : undefined, onChange: function (key) {
                    var value = key;
                    if (value === "custom") {
                        setIsCustomRange(true);
                    }
                    else if (value) {
                        handlePresetChange(value);
                    }
                }, className: "w-28", children: [(0, jsx_runtime_1.jsxs)(react_1.Select.Trigger, { className: "h-8 min-h-8 bg-transparent shadow-none", children: [(0, jsx_runtime_1.jsx)(react_1.Select.Value, {}), (0, jsx_runtime_1.jsx)(react_1.Select.Indicator, {})] }), (0, jsx_runtime_1.jsx)(react_1.Select.Popover, { children: (0, jsx_runtime_1.jsx)(react_1.ListBox, { items: __spreadArray(__spreadArray([], datePresets_1.DATE_PRESETS.slice(5), true), [{ key: "custom", label: "Custom range…", days: -2 }], false), children: function (preset) { return ((0, jsx_runtime_1.jsxs)(react_1.ListBox.Item, { id: preset.key, textValue: preset.label, children: [preset.label, (0, jsx_runtime_1.jsx)(react_1.ListBox.ItemIndicator, {})] })); } }) })] }), (0, jsx_runtime_1.jsx)("span", { className: "mx-1 h-5 w-px bg-border", "aria-hidden": true }), (0, jsx_runtime_1.jsx)(react_1.ButtonGroup, { children: GRANULARITY_OPTIONS.map(function (option) {
                    var active = granularity === option.key;
                    return ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "tertiary", className: (0, react_1.cn)("min-w-0 px-3 text-xs font-medium", active && "bg-primary/10 text-primary"), onPress: function () { return handleGranularityChange(option.key); }, children: option.label }, option.key));
                }) }), isCustomRange && ((0, jsx_runtime_1.jsxs)("div", { className: "flex w-full flex-col gap-3 border-t border-border pt-3 sm:flex-row sm:items-end", children: [(0, jsx_runtime_1.jsx)(date_field_1.DatePickerField, { label: "Start Date", value: customStartDate, onChange: function (value) { return setCustomStartDate(value); }, className: "w-full sm:w-48" }), (0, jsx_runtime_1.jsx)(date_field_1.DatePickerField, { label: "End Date", value: customEndDate, onChange: function (value) { return setCustomEndDate(value); }, className: "w-full sm:w-48" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "primary", onPress: handleCustomDateChange, isDisabled: !customStartDate || !customEndDate, className: "w-full sm:w-auto", children: "Apply" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "tertiary", onPress: function () {
                            setIsCustomRange(false);
                            handlePresetChange("30d");
                        }, className: "w-full sm:w-auto", children: "Cancel" })] }))] }));
};
exports.DashboardFilters = DashboardFilters;
